module.exports = __webpack_public_path__ + "static/media/footer_application.928bdcb5.png";